import React, { ComponentProps } from "react";

import { UnmountClosed as UnmountCollapsedContent } from "react-collapse";
import { createGlobalStyle } from "styled-components";

interface Props extends ComponentProps<"div"> {
  collapseTime?: number;
  className?: string;
  isOpen: boolean;
}

const CollapsibleContainer = (props: Props): React.ReactElement => {
  const { children, collapseTime = 400, className, isOpen, ...rest } = props;
  return (
    <div role="region" {...rest}>
      <CollapseStyle collapseTime={collapseTime} />
      <UnmountCollapsedContent className={className} isOpened={isOpen}>
        {children}
      </UnmountCollapsedContent>
    </div>
  );
};

interface CollapseProps {
  readonly collapseTime: number;
}

const CollapseStyle = createGlobalStyle<CollapseProps>`
  .ReactCollapse--collapse {
    transition: height ${({ collapseTime }) => collapseTime}ms;
  }
`;

export default CollapsibleContainer;
